/**
 * Created by andrey on 09.02.2021.
 */

Map2dDecorators.prototype.getSaveInfo = function () {
    const decorators = [];

    for (const y in this.decorators) {
        for (const x in this.decorators[y]) {
            const toSave = this.decorators[y][x].filter((decorator) => !decorator.isDynamic());
          
            decorators.push(...toSave);
        }
    }

    return decorators.sort((d1, d2) => (d1.x - d2.x) || (d1.y - d2.y)).map((decorator) => decorator.getSaveInfo());
};

Map2dDecorators.prototype.findIntersectingDecorators = function (decorator) {
    const intersecting = [];

    this.iterateDecorators((other) => {
        const decoratorView = decorator.getView();
        const otherView = other.getView();

        if (decoratorView && otherView && cc.rectIntersectsRect(decoratorView.getSceneBoundingBox(), otherView.getSceneBoundingBox())) {
            intersecting.push(other);
        }
    });

    return intersecting;
};

Map2dDecorators.findDecorator = function (map, x, y, decoratorId) {
    const list = map.decorators.decorators[y] && map.decorators.decorators[y][x];
    if (list) {
        return list.slice().reverse().find((d) => d.getDecoratorHash() === decoratorId);
    }
};

EditorClient.registerCommand("produceDecorator", {
    execute: function (editor, command) {
        const decorator = new Map2dDecorator({
            code: command.code,
            x: command.x,
            y: command.y,
            dx: command.dx,
            dy: command.dy,
            rotation: command.rotation || 0,
            scaleX: command.scaleX,
            scaleY: command.scaleY
        });
        editor.map.decorators.addDecorator(decorator.x, decorator.y, decorator);
        editor.map.saveLevel();

        editor.lastProducedDecorator = decorator;

        decorator.createView(decorator);

        const view = decorator.getView();
        if (view) {
            view.setScale(0);
            view.runAction(new cc.ScaleTo(0.2, 1).easing(cc.easeBackOut(1.5)));
            cleverapps.effects.fire("merge.spawn.landing");
        }

        return { type: "removeDecorator", data: { x: command.x, y: command.y, hash: decorator.getDecoratorHash() } };
    }
});

EditorClient.registerCommand("removeDecorator", {
    execute: function (editor, command) {
        const decorator = Map2dDecorators.findDecorator(editor.map, command.x, command.y, command.hash);
        if (!decorator) {
            return;
        }

        command.code = decorator.code;

        const undoData = {
            code: decorator.code,
            x: decorator.x,
            y: decorator.y,
            dx: decorator.dx,
            dy: decorator.dy,
            rotation: decorator.rotation,
            scaleX: decorator.scaleX,
            scaleY: decorator.scaleY
        };

        const view = decorator.getView();
        if (view) {
            view.replaceParentSamePlace(Map2d.currentMap.getMapView().animations);
            decorator.onRemove = () => {};
        }

        editor.map.decorators.removeDecorator(decorator.x, decorator.y, decorator);
        decorator.onRemove();
        editor.map.saveLevel();

        if (view) {
            view.runAction(new cc.Sequence(
                new cc.ScaleTo(0.2, 0).easing(cc.easeIn(2)),
                new cc.RemoveSelf()
            ));
            cleverapps.effects.fire("merge.unit.destroy");
        }

        return { type: "produceDecorator", data: undoData };
    }
});

EditorClient.registerCommand("changeDecoratorCell", {
    execute: function (editor, command) {
        const decorator = Map2dDecorators.findDecorator(editor.map, command.oldX, command.oldY, command.hash);
        if (!decorator) {
            return;
        }

        command.code = decorator.code;

        const prevX = decorator.x;
        const prevY = decorator.y;
        const prevDx = decorator.dx;
        const prevDy = decorator.dy;
        const prevList = editor.map.decorators.getDecorators(prevX, prevY);
        const prevIndex = prevList ? prevList.indexOf(decorator) : undefined;

        let index = command.index;
        if (index !== undefined) {
            const list = editor.map.decorators.getDecorators(command.x, command.y);
            const selfIndex = list ? list.indexOf(decorator) : -1;
            if (selfIndex !== -1 && selfIndex < index) {
                index--;
            }
        }

        editor.map.decorators.removeDecorator(decorator.x, decorator.y, decorator);

        decorator.x = command.x;
        decorator.y = command.y;
        decorator.dx = command.dx;
        decorator.dy = command.dy;

        editor.map.decorators.addDecorator(command.x, command.y, decorator, index);

        decorator.updateLargeBox();
        decorator.updateParent();
        decorator.updateDecorator(true);
        editor.map.saveLevel();

        cleverapps.effects.fire("merge.spawn.landing");

        return {
            type: "changeDecoratorCell",
            data: {
                oldX: command.x, oldY: command.y, x: prevX, y: prevY, hash: decorator.getDecoratorHash(), dx: prevDx, dy: prevDy, index: prevIndex
            } 
        };
    }
});

EditorClient.registerCommand("moveDecorator", {
    execute: function (editor, command) {
        const decorator = Map2dDecorators.findDecorator(editor.map, command.x, command.y, command.hash);
        if (!decorator) {
            return;
        }

        command.code = decorator.code;

        const prevDx = decorator.dx;
        const prevDy = decorator.dy;

        decorator.dx = command.dx;
        decorator.dy = command.dy;
        decorator.updateLargeBox();
        decorator.updateDecorator(true);
        editor.map.saveLevel();

        cleverapps.effects.fire("merge.drag.start");

        return {
            type: "moveDecorator",
            data: {
                x: command.x, y: command.y, hash: decorator.getDecoratorHash(), dx: prevDx, dy: prevDy
            } 
        };
    }
});

EditorClient.registerCommand("rotateDecorator", {
    execute: function (editor, command) {
        const decorator = Map2dDecorators.findDecorator(editor.map, command.x, command.y, command.hash);
        if (!decorator) {
            return;
        }

        command.code = decorator.code;

        const prevRotation = decorator.rotation;

        decorator.rotation = command.rotation;
        decorator.updateLargeBox();
        decorator.updateDecorator(true);
        editor.map.saveLevel();

        cleverapps.effects.fire("merge.drag.start");

        return {
            type: "rotateDecorator",
            data: {
                x: command.x, y: command.y, hash: decorator.getDecoratorHash(), rotation: prevRotation
            } 
        };
    }
});

EditorClient.registerCommand("scaleDecorator", {
    execute: function (editor, command) {
        const decorator = Map2dDecorators.findDecorator(editor.map, command.x, command.y, command.hash);
        if (!decorator) {
            return;
        }

        command.code = decorator.code;

        const prevScaleX = decorator.scaleX;
        const prevScaleY = decorator.scaleY;

        decorator.scaleX = Math.round(command.scaleX * 100) / 100;
        decorator.scaleY = Math.round(command.scaleY * 100) / 100;
        decorator.updateLargeBox();
        decorator.updateDecorator(true);
        editor.map.saveLevel();

        cleverapps.effects.fire("merge.drag.start");

        return {
            type: "scaleDecorator",
            data: {
                x: command.x, y: command.y, hash: decorator.getDecoratorHash(), scaleX: prevScaleX, scaleY: prevScaleY
            } 
        };
    }
});
